import { atom, WritableAtom } from 'jotai';

export function atomWithWebStorage<Value>(
  key: string,
  initialValue: Value,
  storage = localStorage
): WritableAtom<Value, [nextValue: Value], void> {
  const storedValue = storage.getItem(key);
  const isString = typeof initialValue === 'string';

  let storageValue;
  if (storedValue) {
    storageValue = isString ? storedValue : storedValue === 'true';
  }

  const baseAtom = atom(storageValue ?? initialValue);

  return atom(
    (get) => get(baseAtom) as Value,
    (_get, set, nextValue: Value) => {
      set(baseAtom, nextValue);
      storage.setItem(key, nextValue!.toString());
    },
  );
}
